<div class="workspace-card">
  <div class="workspace-card-header">
    <div *ngIf="_isPreset; else customActions">
      <span
        *ngIf="_workspace as workspaceSummary"
        class="mdi mdi-content-copy"
        (click)="cloneAction.onClick(workspaceSummary)"
      ></span>
    </div>
    <h5 class="mb-0">
      <nf-inline-edit
        [alwaysShowButtons]="false"
        [editable]="_isPreset === false"
        [transparent]="true"
        [editButtonClickOnly]="true"
        [disablePopover]="false"
        [ngbTooltip]="title"
        (save)="updateName()"
      >
        <input type="text" class="form-control" [(ngModel)]="title" />
      </nf-inline-edit>
    </h5>
    <div
      *ngIf="isDefault"
      class="badge badge-light"
      ngbTooltip="This workspace will be activated automatically when Helios starts."
    >
      Default
    </div>
  </div>
  <div class="workspace-card-description">
    <p
      class="description-text"
      [ngbTooltip]="description"
      container="body"
      placement="top"
    >
      {{ description }}
    </p>
    <span
      class="mdi mdi-pencil"
      *ngIf="_isPreset === false"
      (click)="onDescriptionClick()"
      ngbTooltip="Edit"
    ></span>
  </div>
</div>

<ng-template #customActions>
  <div ngbDropdown *ngIf="_workspace as workspaceSummary">
    <span
      class="mdi mdi-dots-horizontal"
      ngbTooltip="Workspace Actions"
      ngbDropdownToggle
      id="workspace-actions"
    >
    </span>
    <div ngbDropdownMenu aria-labelledby="workspace-actions">
      <div
        *ngFor="let action of customWorkspaceCardActions"
        [ngbTooltip]="action.tooltip(workspaceSummary, isActive)"
      >
        <button
          class="dropdown-item btn btn-link"
          (click)="action.onClick(workspaceSummary)"
          [disabled]="action.disabled(workspaceSummary, isActive)"
        >
          {{ action.displayName }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
